var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section"},[(_vm.approved)?_c('div',{staticClass:"container"},[_c('b-notification',{staticClass:"d-flex justify-content-center align-items-center",attrs:{"type":"is-success","has-icon":"","closable":false}},[_c('p',[_vm._v("Your email has been successfully verified!")])])],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }